const BRANCH_STATE = {
    company: {
      branch: {
        name : '',
      },
      company: {
        fancy_name: ''
      }
    }
  }

export function currentBranchReducer( state = BRANCH_STATE, action ){
    switch( action.type ){
        case "SET_CURRENT_BRANCH": return action.payload
        default: return state
    }
}

export function branchesReducer( state = [], action ){
    switch( action.type ){
        case "SET_BRANCHES": return action.payload
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/branches/reducers.js